<template>
  <BPCard
  :headerConfig="{ title: this.$t('balances') }"
  hideNonTract
  :contractMode.sync="contractMode">
    <v-row>
      <v-col>
        <v-tabs
        v-model="currentTab">
          <v-tab>
            <span>
              {{ $t('advances') }}
            </span>
          </v-tab>
          <v-tab>
            <span>
              {{ $t('tractDepletion') }}
            </span>
          </v-tab>
          <v-tab>
            <span>
              {{ $t('bonds') }}
            </span>
          </v-tab>
          <v-tab>
            <span>
              {{ $t('obligation') }}
            </span>
          </v-tab>
          <v-tab>
            <span>
              {{ $t('glReconciliation') }}
            </span>
          </v-tab>
          <v-tab v-if="!hideAdjustingEntries">
            <span>
              {{ $t('adjustingEntries') }}
            </span>
          </v-tab>
          <v-tab-item>
            <Advances/>
          </v-tab-item>
          <v-tab-item>
            <Depletion/>
          </v-tab-item>
          <v-tab-item>
            <Bonds/>
          </v-tab-item>
          <v-tab-item>
            <Obligation/>
          </v-tab-item>
          <v-tab-item>
            <GLReconciliation/>
          </v-tab-item>
          <v-tab-item>
            <AdjustingEntries
            :contractMode="contractMode"/>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </BPCard>
</template>

<script>
import { ContractMode, AdjustingEntriesFrequency } from '@/utils/Enumerations.js'
import { mapGetters } from 'vuex'

const tabs = {
  advances: 0,
  tractDepletion: 1,
  bonds: 2,
  obligation: 3,
  glReconciliation: 4,
  adjustingEntries: 5
}

export default {
  name: 'Balances',
  components: {
    BPCard: () => import('@/components/core/BPCard.vue'),
    Advances: () => import('@/components/accounting/balances/Advances.vue'),
    AdjustingEntries: () => import('@/components/accounting/balances/AdjustingEntries.vue'),
    Depletion: () => import('@/components/accounting/balances/Depletion.vue'),
    Bonds: () => import('@/components/accounting/balances/Bonds.vue'),
    Obligation: () => import('@/components/accounting/balances/Obligation.vue'),
    GLReconciliation: () => import('@/components/accounting/balances/GLReconciliation.vue')
  },

  data: () => ({
    contractMode: null,
    currentTab: tabs.advances
  }),

  watch: {
    currentTab (val) {
      if (val === tabs.adjustingEntries) {
        this.contractMode = ContractMode.Logs
        return
      }
      this.contractMode = null
    }
  },

  computed: {
    ...mapGetters('user', ['companyInfo']),
    hideAdjustingEntries () {
      const companyAdjustingEntriesFrequency = this.adjustingEntriesFrequency(this.companyInfo.adjustingEntriesFrequency)
      return companyAdjustingEntriesFrequency.value === AdjustingEntriesFrequency.None.value
    }
  },

  methods: {
    adjustingEntriesFrequency: (x) => AdjustingEntriesFrequency.forInt(x)
  }
}
</script>
